import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ActionCodeSettings, Auth, authState, createUserWithEmailAndPassword, EmailAuthCredential, EmailAuthProvider, onAuthStateChanged, reauthenticateWithCredential, sendEmailVerification, sendPasswordResetEmail, signInWithEmailAndPassword, signOut, updatePassword, updateProfile, User, UserCredential, verifyBeforeUpdateEmail } from '@angular/fire/auth';
import { Database, DatabaseReference, DataSnapshot, equalTo, get, object, objectVal, orderByChild, push, query, Query, ref, remove, set, update } from '@angular/fire/database';
import { ProviderSignInRequestBody, ProviderSignUpRequestBody } from '@lfg-interface/auth.interfaces';
import { Provider, ProviderCustomRegister } from '@lfg-interface/provider.interfaces';
import { catchError, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  DATABASE_PATH: string = 'CarFinderGeniePlatform/providers/';

  constructor(
              private AUTH: Auth,
              private DATABASE: Database,
              private httpClient: HttpClient,
              ) {
                this.checkAuthStateChanges();
              }

  public getAuthState(): Observable<User | null> {
    return authState(this.AUTH);
  }

  public checkAuthStateChanges(): void {
    onAuthStateChanged(this.AUTH, async (user: User | null) => {
      if (user?.uid && user.email) {
        await this.syncProviderEmail(user);
      }

      // if (user) {
      //   // // // console.log('Esta');
      // } else {
      //   // // // console.log('Ya no esta');
      //   indexedDB.databases().then((dbs) => {
      //     dbs.forEach((db) => indexedDB.deleteDatabase(db.name!));
      //   });
      // }
    });
  }

  private async syncProviderEmail(user: User): Promise<void> {
    const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `${this.DATABASE_PATH}/${user.uid}/user_profile`);
    const snapshot: DataSnapshot = await get(DATABASE_REFERENCE);

    if (!snapshot.exists()) {
      return;
    }

    const providerProfile = snapshot.val();
    if (providerProfile?.email === user.email) {
      return;
    }

    await update(DATABASE_REFERENCE, {
      email: user.email
    });
  }

  public async createNewProviderAccount(sign_up_request: ProviderSignUpRequestBody): Promise<User | null> {
    return new Promise(async (resolve, reject) => {
      createUserWithEmailAndPassword(this.AUTH, sign_up_request.email, sign_up_request.password).then((response: UserCredential) => {
        updateProfile(response.user, {
          displayName: sign_up_request.name
        }).then(() => {
          const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `${this.DATABASE_PATH}/${response.user.uid}`);
          set(DATABASE_REFERENCE, {
            ads_data: {
              ads_banner: '',
              ads_phone: '',
              available_for_ads: false,
              ads_countries: [],
              facebook_url: '',
              instagram_url: '',
              website_url: '',
              ads_marketing_1: { picture_url: '', ad_url: '',},
              ads_marketing_2: { picture_url: '', ad_url: '',},
              ads_marketing_3: { picture_url: '', ad_url: '',},
            },
            business_data: {
              business_name: '',
              business_logo: '',
              business_description: '',
              entity_type: sign_up_request.user_type,
              business_address: {
                street: '',
                town: '',
                zip_code: '',
                country: sign_up_request.country,
              },
              car_type: '',
              job_type: '',
              phone: ''
            },
            device: {

            },
            selected_brands: {

            },
            user_profile: {
              country: sign_up_request.country,
              email: sign_up_request.email,
              name: sign_up_request.name,
              uid: response.user.uid,
              user_type: 'provider',
              timestamp: Date.now(),
              register_completed: false,
              payment_data: {
                customer_id: '',
                subscriptions: {},
                cards: {}
              },
            }
            }).then(() => {
              const CUSTOMER_STRIPE_DATA = {
                name: sign_up_request.name,
                email: sign_up_request.email
              };
              const CSD_AS_JSON: string = JSON.stringify(CUSTOMER_STRIPE_DATA);
              this.httpClient.post(`${environment.cloud_functions_urls.createStripeCustomer}`, CSD_AS_JSON, {
                headers: new HttpHeaders({
                  'Content-Type': 'application/json'
                })
              }).pipe(catchError((errorTest:HttpErrorResponse): any => {
                if (errorTest.error instanceof ErrorEvent) {
                  reject();
                } else {
                  reject();
                }
              })).subscribe(($response: any) => {
                const STRIPE_DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `${this.DATABASE_PATH}/${response.user.uid}/user_profile/payment_data/`)
                update(STRIPE_DATABASE_REFERENCE, {
                  customer_id: $response.data.id
                }).then(() => {
                  const AUTH_DATA_VALIDATION = {
                    display_name: sign_up_request.name,
                    email: sign_up_request.email,
                    app: 'provider'
                  };
                  const ADV_AS_JSON: string = JSON.stringify(AUTH_DATA_VALIDATION);
                  this.httpClient.post(`${environment.cloud_functions_urls.sendWelcomeEmail}`, ADV_AS_JSON, {
                    headers: new HttpHeaders({
                      'Content-Type': 'application/json'
                    })
                  }).pipe(catchError((errorTest:HttpErrorResponse): any => {
                    if (errorTest.error instanceof ErrorEvent) {
                      reject();
                    } else {
                      reject();
                    }
                  })).subscribe(($$response: any) => {
                      resolve($response)
                    });
                  },(error: any) => {
                  reject()
                });
              },(error: any) => {
              reject()
            });
          });
        });
      }).catch((error: firebase.default.FirebaseError) => {
        reject(error);
      });
    });
  }

  public async getStripeProducts(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.httpClient.post(`${environment.cloud_functions_urls.getStripeProducts}`, {}).pipe(catchError((errorTest:HttpErrorResponse): any => {
        if (errorTest.error instanceof ErrorEvent) {
          reject();
        } else {
          reject();
        }
      })).subscribe((response: any) => {
        resolve(response);
      },(error: any) => {
        reject()
      });;
    });
  }

  public async getStripeProductsPrice(id: string): Promise<any> {
    return new Promise(async (resolve, reject) => {
      const PRODUCT_ID: any = {
        id: id
      };
      const PI_AS_JSON: string = JSON.stringify(PRODUCT_ID);
      this.httpClient.post(`${environment.cloud_functions_urls.getStripeProductPrice}`, PI_AS_JSON).pipe(catchError((errorTest:HttpErrorResponse): any => {
        if (errorTest.error instanceof ErrorEvent) {
          reject();
        } else {
          reject();
        }
      })).subscribe((response: any) => {
        resolve(response);
      },(error: any) => {
        reject()
      });;
    });
  }

  public async resendEmailVerification(user: User | null): Promise<void> {
    return new Promise(async (resolve, reject) => {
      // Obtener la información del proveedor desde la base de datos
      const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `${this.DATABASE_PATH}/${user?.uid}`);
      get(DATABASE_REFERENCE).then((snapshot) => {
        const providerData = snapshot.val();
        if (providerData && providerData.user_profile) {
          const AUTH_DATA_VALIDATION = {
            display_name: providerData.user_profile.name,
            email: providerData.user_profile.email,
            app: 'provider'
          };
          const ADV_AS_JSON: string = JSON.stringify(AUTH_DATA_VALIDATION);
          this.httpClient.post(`${environment.cloud_functions_urls.sendWelcomeEmail}`, ADV_AS_JSON, {
            headers: new HttpHeaders({
              'Content-Type': 'application/json'
            })
          }).pipe(catchError((errorTest:HttpErrorResponse): any => {
            // console.error('Error al enviar correo con plantilla:', errorTest);
            // Fallback al método básico de Firebase si falla el envío con plantilla
            sendEmailVerification(user as User).then((response: void) => {
              resolve();
            }).catch((error: firebase.default.FirebaseError) => {
              reject(error);
            });
            return [];
          })).subscribe((response: any) => {
            // // // console.log('Correo con plantilla enviado exitosamente');
            resolve();
          });
        } else {
          // Fallback al método básico de Firebase si no se encuentra la información del proveedor
          sendEmailVerification(user as User).then((response: void) => {
            resolve();
          }).catch((error: firebase.default.FirebaseError) => {
            reject(error);
          });
        }
      }).catch((error) => {
        // Fallback al método básico de Firebase si hay error al obtener datos
        sendEmailVerification(user as User).then((response: void) => {
          resolve();
        }).catch((error: firebase.default.FirebaseError) => {
          reject(error);
        });
      });
    });
  }

  public async accessAsProvider(sign_in_request: ProviderSignInRequestBody): Promise<User | null> {
    return new Promise(async (resolve, reject) => {
      signInWithEmailAndPassword(this.AUTH, sign_in_request.email, sign_in_request.password).then((response: UserCredential) => {
        resolve(response.user);
      }).catch((error: firebase.default.FirebaseError) => {
        reject(error);
      });
    });
  }

  public async setSessionToken(user: User | null): Promise<void> {
    const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `CarFinderGeniePlatform/providers/${user?.uid}/user_profile/session_mngmnt/sessions`);
    const ID: number = Date.now();
    await push(DATABASE_REFERENCE, {
      session_token: ID,
      updated_at: new Date().toISOString()
    }).then(() => {
      localStorage.setItem('session_token', `${ID}`);
      this.startToMonitorSession(`${user?.uid}`);
    });
  }

  startToMonitorSession(uid: string): void {
  const SESSION_TOKEN = localStorage.getItem('session_token');
  const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `CarFinderGeniePlatform/providers/${uid}/user_profile/session_mngmnt/sessions`);

  objectVal(DATABASE_REFERENCE).subscribe(async (response: any) => {
    if (!response) return;
    const sessionEntries = Object.entries(response) as [string, { session_token: number, updated_at: string }][];
    // 1. Verificar si la sesión actual sigue activa
    const currentSessionStillExists = sessionEntries.some(([_, data]) => `${data.session_token}` === SESSION_TOKEN);

    if (!currentSessionStillExists) {
      // console.warn('Sesión actual fue eliminada. Cerrando sesión...');
      await this.signOut();
      return;
    }

    // 2. Eliminar la más antigua si hay más de 2 sesiones
    if (sessionEntries.length > 2) {
      sessionEntries.sort((a, b) =>
        new Date(a[1].updated_at).getTime() - new Date(b[1].updated_at).getTime()
      );
      const oldestSessionKey = sessionEntries[0][0];
      const DELETE_DATABASE_REFERENCE: DatabaseReference =
        ref(this.DATABASE, `CarFinderGeniePlatform/providers/${uid}/user_profile/session_mngmnt/sessions/${oldestSessionKey}`);
      await remove(DELETE_DATABASE_REFERENCE);
    }
  });
}

  public getProviderInfoByUID(uid: string): Observable<Provider | null> {
    const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `${this.DATABASE_PATH}/${uid}`);
    return objectVal<Provider>(DATABASE_REFERENCE);
  }

  public async sendPasswordResetLink(email: string): Promise<void> {
    return new Promise(async (resolve, reject) => {
      sendPasswordResetEmail(this.AUTH, email).then((response: void) => {
        resolve();
      }).catch((error: firebase.default.FirebaseError) => {
        reject(error);
      });
    });
  }

  public async sendEmailV(user: User, email: string): Promise<void> {
    return new Promise(async (resolve, reject) => {
      sendEmailVerification(user, {url: 'https://leadsfindergenie.com'}).then((response: void) => {
        resolve();
      }).catch((error: firebase.default.FirebaseError) => {
        reject(error);
      });
    });
  }

  public async createNewPaymentLink(data: any, uid: string): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `${this.DATABASE_PATH}/${uid}/user_profile/payment_data/subscriptions/`);
      const CARD_PAYLOAD: any = {
        stripe_customer_id: data.customer_id,
        price_id: data.price_id
      }
      const PAYLOAD_AS_TEXT: string = JSON.stringify(CARD_PAYLOAD);
        this.httpClient.post(`${environment.cloud_functions_urls.getStripePaymentLink}`, PAYLOAD_AS_TEXT).pipe(catchError((errorTest:HttpErrorResponse): any => {
          if (errorTest.error instanceof ErrorEvent) {
            reject();
          } else {
            reject();
          }
        })).subscribe((response: any) => {
          push(DATABASE_REFERENCE, {
              checkout_session_id: response.data.id,
              checkout_link: response.data.url,
              subscription: ''
          }).then(() => {
            resolve(response)
          });
        }, (error: any) => { reject() }, () => {});
    });
  }

  public async completeProviderRegister(provider: Provider | null, uid: string): Promise<void> {
    // // // console.log('provider', provider);
    return new Promise(async (resolve, reject) => {;
      const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `${this.DATABASE_PATH}/${uid}`);
      update(DATABASE_REFERENCE, (provider as Provider)).then((response) => {
        const CUSTOMER_UPDATE_DATA = {
          uid: uid,
          phone: `+1${provider?.business_data?.phone}`
        };
        const PAYLOAD_AS_TEXT: string = JSON.stringify(CUSTOMER_UPDATE_DATA);
        this.httpClient.post(`${environment.cloud_functions_urls.updateUserPhoneNumber}`, PAYLOAD_AS_TEXT).pipe(catchError((errorTest:HttpErrorResponse): any => {
          if (errorTest.error instanceof ErrorEvent) {
            reject();
          } else {
            reject();
          }
        })).subscribe((response: any) => {}, (error: any) => { reject() }, () => { resolve() });
        resolve();
      }).catch((error: firebase.default.FirebaseError) => {
        reject(error);
      });
    });
  }

  // public async signOut(): Promise<void> {
  //   return new Promise(async (resolve, reject) => {
  //     signOut(this.AUTH).then(() => {
  //       resolve();
  //     }).catch((error: firebase.default.FirebaseError) => {
  //       reject();
  //     });
  //   });
  // }

  public async signOut(): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        const token = localStorage.getItem('session_token');
        const uid = this.AUTH.currentUser?.uid;
        if (uid && token) {
          const sessionsRef = ref(this.DATABASE, `CarFinderGeniePlatform/providers/${uid}/user_profile/session_mngmnt/sessions`);
          const snapshot = await get(sessionsRef);
          const sessions = snapshot.val();
          if (sessions) {
            const sessionKeyToRemove = Object.entries(sessions).find(([_, value]: any) => `${value.session_token}` === token)?.[0];
            if (sessionKeyToRemove) {
              await remove(ref(this.DATABASE, `CarFinderGeniePlatform/providers/${uid}/user_profile/session_mngmnt/sessions/${sessionKeyToRemove}`));
            }
          }
        }

        localStorage.removeItem('session_token');

        // Sign out from Firebase Auth
        await signOut(this.AUTH);

        // Clear storages and cookies
        try { localStorage.clear(); } catch (e) {}
        try { sessionStorage.clear(); } catch (e) {}
        try { this.clearAllCookies(); } catch (e) {}

        // Unregister service workers (ensures SW won't serve stale cached index.html)
        try {
          if ('serviceWorker' in navigator) {
            const regs = await navigator.serviceWorker.getRegistrations();
            await Promise.all(regs.map((r) => r.unregister()));
          }
        } catch (e) {
          // ignore
        }

        // Clear CacheStorage and WebSQL
        try { await this.clearCacheStorage(); } catch (e) {}
        try { this.clearWebSQL(); } catch (e) {}

        // Remove Firebase auth/local DB entries if present
        try {
          // Known Firebase local storage key
          localStorage.removeItem('firebase:authUser:default');
        } catch (e) {}

        // Delete all IndexedDB databases (best-effort)
        try {
          if ((indexedDB as any).databases) {
            const dbs = await (indexedDB as any).databases();
            await Promise.all(dbs.map((db: any) => db.name ? new Promise((res) => { indexedDB.deleteDatabase(db.name); setTimeout(res, 200); }) : Promise.resolve()));
          } else {
            // Fallback to known Firebase DB name
            try { indexedDB.deleteDatabase('firebaseLocalStorageDb'); } catch (e) {}
          }
        } catch (e) {
          // ignore
        }

        // Force a full reload to ensure the client loads a fresh app shell
        try { window.location.href = '/'; } catch (e) {}

        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  private clearWebSQL(): void {
    if ('openDatabase' in window) {
      try {
        const db = (window as any).openDatabase('', '', '', 0);
        if (db) {
          db.transaction((tx: any) => {
            tx.executeSql('SELECT name FROM sqlite_master WHERE type="table"', [], (tx: any, result: any) => {
              for (let i = 0; i < result.rows.length; i++) {
                const tableName = result.rows.item(i).name;
                tx.executeSql(`DROP TABLE IF EXISTS ${tableName}`);
              }
            });
          });
        }
      } catch (error) {
        // WebSQL puede no estar disponible o fallar
      }
    }
  }

  private async clearCacheStorage(): Promise<void> {
    return new Promise((resolve) => {
      if ('caches' in window) {
        caches.keys().then((cacheNames) => {
          const deletePromises = cacheNames.map((cacheName) => {
            return caches.delete(cacheName);
          });

          Promise.all(deletePromises).then(() => resolve());
        }).catch(() => resolve());
      } else {
        resolve();
      }
    });
  }

  private clearAllCookies(): void {
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();

      // Eliminar cookie estableciendo fecha de expiración en el pasado
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.${window.location.hostname}`;
    }
  }

  public async setDeviceId(token: string, uid: string): Promise<any> {
    return new Promise(async (resolve, reject) => {
      const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `CarFinderGeniePlatform/providers/${uid}/`);
      update(DATABASE_REFERENCE, {
        device_id: token,
      }).then(() => {
        resolve({status: 'success'});
      }).catch((error) => {
        reject({status: 'error', data: error});
      });
    });
  }

  public async removeDeviceId(uid: string): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `CarFinderGeniePlatform/providers/${uid}/device_id/`);
      remove(DATABASE_REFERENCE).then(() => {
        resolve();
      }).catch((error) => {
        reject({status: 'error', data: error});
      });
    });
  }

  public async updateUserProfilePicture(url: string): Promise<void> {
    return new Promise(async (resolve, reject) => {
      onAuthStateChanged(this.AUTH, (user: User | null) => {
        updateProfile(user as User, {
          photoURL: url
        }).then(async () => {
          const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `CarFinderGeniePlatform/providers/${user?.uid}/`);
          await update(DATABASE_REFERENCE, {
            photoURL: url
          }).then(() => {
            resolve();
          }).catch((error) => {
            reject();
          });
        }).catch((error) => {
          reject();
        });
      });
    });
  }

  public async updateAdsBannerPicture(provider: Provider): Promise<void> {
    return new Promise(async (resolve, reject) => {
      onAuthStateChanged(this.AUTH, async (user: User | null) => {
        const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `CarFinderGeniePlatform/providers/${user?.uid}/`);
          await update(DATABASE_REFERENCE, provider).then(() => {
            resolve();
          }).catch((error) => {
            reject();
          });
      });
    });
  }

  public async updateAdsLogoPicture(provider: Provider): Promise<void> {
    return new Promise(async (resolve, reject) => {
      onAuthStateChanged(this.AUTH, async (user: User | null) => {
        const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `CarFinderGeniePlatform/providers/${user?.uid}/`);
        if (provider.ads_data) {
          provider.ads_data.available_for_ads = true;
        }
        await update(DATABASE_REFERENCE, provider).then(() => {
          resolve();
        }).catch((error) => {
          reject();
        });
      });
    });
  }

  public async updateUserProfile(provider: Provider | null): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const CURRENT_USER: User | null = this.AUTH.currentUser;
      updateProfile(CURRENT_USER as User, {
        displayName: provider?.user_profile?.name,
      });
      const UID: string | undefined = CURRENT_USER?.uid;
      const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `CarFinderGeniePlatform/providers/${UID}/`);
      update(DATABASE_REFERENCE, (provider as Provider)).then(() => {
        const CUSTOMER_UPDATE_DATA = {
          uid: UID,
          phone: provider?.business_data?.phone
        };
        const PAYLOAD_AS_TEXT: string = JSON.stringify(CUSTOMER_UPDATE_DATA);
        this.httpClient.post(`${environment.cloud_functions_urls.updateUserPhoneNumber}`, PAYLOAD_AS_TEXT).pipe(catchError((errorTest:HttpErrorResponse): any => {
          if (errorTest.error instanceof ErrorEvent) {
            reject();
          } else {
            reject();
          }
        })).subscribe((response: any) => {}, (error: any) => { reject() }, () => { resolve() });
        resolve();
      }).catch((error: firebase.default.FirebaseError) => {
        reject();
      });
    });
  }

  public async updateUserEmailAccount(email: string): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const CURRENT_USER: User | null = this.AUTH.currentUser;
      if (!CURRENT_USER) {
        reject({ code: 'auth/user-not-found' });
        return;
      }

      const ACTION_CODE_SETTINGS: ActionCodeSettings = {
        url: `${window.location.origin}/sign-in`,
        handleCodeInApp: false,
      };

      verifyBeforeUpdateEmail(CURRENT_USER, email, ACTION_CODE_SETTINGS).then(() => {
        resolve();
      }).catch((error: firebase.default.FirebaseError) => {
        reject();
      });
    });
  }

  public async updateUserPassword(password_data: any): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const CURRENT_USER: User | null = this.AUTH.currentUser;
      const CREDENTIALS: EmailAuthCredential = EmailAuthProvider.credential(password_data.email, password_data.currentPassword);
      reauthenticateWithCredential(CURRENT_USER as User, CREDENTIALS).then((value: UserCredential) => {
        updatePassword(CURRENT_USER as User, password_data.newPassword).then(() => {
          resolve();
        }).catch((error: firebase.default.FirebaseError) => {
          reject();
        });
      });
    });
  }

  public async updateBrandData(data: Provider): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `CarFinderGeniePlatform/providers/${data.user_profile?.uid}/`);
      update(DATABASE_REFERENCE, data).then(() => {
        resolve();
      }).catch((error: firebase.default.FirebaseError) => {
        reject();
      });
    });
  }

  changeCraneJobStatus(data: any): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `CarFinderGeniePlatform/providers/${data.uid}/`);
      update(DATABASE_REFERENCE, {
        is_turn_active: data.status
      }).then(() => {
        resolve();
      }).catch((error: firebase.default.FirebaseError) => {
        reject();
      });
    });
  }

  public async getCustomerStripeSubscription(checkout_session_id: string): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const CARD_PAYLOAD: any = {
        cs_id: checkout_session_id,
      };
      const PAYLOAD_AS_TEXT: string = JSON.stringify(CARD_PAYLOAD);
      this.httpClient.post(`${environment.cloud_functions_urls.getCustomerSubscription}`, PAYLOAD_AS_TEXT).pipe(catchError((errorTest:HttpErrorResponse): any => {
        if (errorTest.error instanceof ErrorEvent) {
          reject(errorTest);
        } else {
          reject(errorTest);
        }
      })).subscribe((response: any) => {
        resolve(response)
      }, (error: any) => { reject(error) }, () => {});
    });
  }

  public async getCustomerStripeSubscriptionById(subscription_id: string): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const CARD_PAYLOAD: any = {
        subscription_id: subscription_id,
      };
      const PAYLOAD_AS_TEXT: string = JSON.stringify(CARD_PAYLOAD);
      this.httpClient.post(`${environment.cloud_functions_urls.getCustomerSubscriptionById}`, PAYLOAD_AS_TEXT).pipe(catchError((errorTest:HttpErrorResponse): any => {
        if (errorTest.error instanceof ErrorEvent) {
          reject();
        } else {
          reject();
        }
      })).subscribe((response: any) => {
        resolve(response)
      }, (error: any) => { reject() }, () => {});
    });
  }

  public async addNewPaymentMethod(data: any): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const CARD_PAYLOAD: any = {
        customer_id: data.customer_id,
      }
      const PAYLOAD_AS_TEXT: string = JSON.stringify(CARD_PAYLOAD);
      this.httpClient.post(`${environment.cloud_functions_urls.addNewPaymentMethod}`, PAYLOAD_AS_TEXT).pipe(catchError((errorTest:HttpErrorResponse): any => {
        if (errorTest.error instanceof ErrorEvent) {
          reject();
        } else {
          reject();
        }
      })).subscribe((response: any) => {
        resolve(response)
      }, (error: any) => { reject() }, () => {});
    });
  }

  public async getCustomerPaymentMethodList(payload: {customer_id: string}): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const PAYLOAD_AS_TEXT: string = JSON.stringify(payload);
      this.httpClient.post(`${environment.cloud_functions_urls.getCustomerPaymentMethodList}`, PAYLOAD_AS_TEXT).pipe(catchError((errorTest:HttpErrorResponse): any => {
        if (errorTest.error instanceof ErrorEvent) {
          reject();
        } else {
          reject();
        }
      })).subscribe((response: any) => {
        resolve(response);
      }, (error: any) => { reject() }, () => {});
    });
  }

  public async deletePaymentMethod(data: any): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const CARD_PAYLOAD: any = {
        pm_id: data.pm_id,
      }
      const PAYLOAD_AS_TEXT: string = JSON.stringify(CARD_PAYLOAD);
      this.httpClient.post(`${environment.cloud_functions_urls.deletePaymentMethod}`, PAYLOAD_AS_TEXT).pipe(catchError((errorTest:HttpErrorResponse): any => {
        if (errorTest.error instanceof ErrorEvent) {
          reject();
        } else {
          reject();
        }
      })).subscribe((response: any) => {
        resolve(response)
      }, (error: any) => { reject() }, () => {});
    });
  }

  public async deleteUserAccount(data: any): Promise<any> {
    return new Promise(async (resolve, reject) => {
      const CARD_PAYLOAD: any = {
        subs_id: data.subs_id,
        customer_id: data.customer_id,
      }
      const PAYLOAD_AS_TEXT: string = JSON.stringify(CARD_PAYLOAD);
      this.httpClient.post(`${environment.cloud_functions_urls.deleteCustomer}`, PAYLOAD_AS_TEXT).pipe(catchError((errorTest:HttpErrorResponse): any => {
        if (errorTest.error instanceof ErrorEvent) {
          reject();
        } else {
          reject();
        }
      })).subscribe(async (response: any) => {
        const CURRENT_USER: User | null = this.AUTH.currentUser;
        const DATABASE_REF: DatabaseReference = ref(this.DATABASE, `CarFinderGeniePlatform/providers/${CURRENT_USER?.uid}/`)
        await remove(DATABASE_REF).then(async () => {
          // Eliminando Inventario
          const INVENTORY_REF: DatabaseReference = ref(this.DATABASE, 'CarFinderGenieaPlatform/inventory/');
          const INVENTORY_QUERY: Query = query(INVENTORY_REF, orderByChild('seller_uid'), equalTo(`${CURRENT_USER?.uid}`));
          const INVENTORY_SNAPSHOT: DataSnapshot = await get(INVENTORY_QUERY);
          if (!INVENTORY_SNAPSHOT.exists()) {

          } else {
            const INVENTORY_UPDATES: any = {};
            INVENTORY_SNAPSHOT.forEach((child: DataSnapshot) => {
              INVENTORY_UPDATES[child.key!] = null;
            });
            await update(INVENTORY_REF, INVENTORY_UPDATES).then(async () => {
              // Eliminando chats
              const CHATS_REF: DatabaseReference = ref(this.DATABASE, 'CarFinderGenieaPlatform/chats/');
              const CHATS_QUERY: Query = query(CHATS_REF, orderByChild('basic_data/created_by'), equalTo(`${CURRENT_USER?.uid}`));
              const CHATS_SNAPSHOT: DataSnapshot = await get(CHATS_QUERY);
              if (!CHATS_SNAPSHOT.exists()) {

              } else {
                const CHATS_UPDATES: any = {};
                INVENTORY_SNAPSHOT.forEach((child: DataSnapshot) => {
                  CHATS_UPDATES[child.key!] = null;
                });
                await update(CHATS_REF, CHATS_UPDATES).then(async () => {
                  // Eliminando mensajes
                  // Eliminando chats
                  const MESSAGES_REF: DatabaseReference = ref(this.DATABASE, 'CarFinderGenieaPlatform/messages/');
                  const MESSAGES_QUERY: Query = query(MESSAGES_REF, orderByChild('sender_uid'), equalTo(`${CURRENT_USER?.uid}`));
                  const MESSAGES_SNAPSHOT: DataSnapshot = await get(MESSAGES_QUERY);
                  if (!MESSAGES_SNAPSHOT.exists()) {

                  } else {
                    const MESSAGES_UPDATES: any = {};
                    MESSAGES_SNAPSHOT.forEach((child: DataSnapshot) => {
                      MESSAGES_UPDATES[child.key!] = null;
                    });
                    await update(MESSAGES_REF, MESSAGES_UPDATES).then(async () => {
                      const CREDENTIALS: EmailAuthCredential = EmailAuthProvider.credential(`${CURRENT_USER?.email}`, data.password);
                      await reauthenticateWithCredential(CURRENT_USER as User, CREDENTIALS).then(async (value: UserCredential) => {
                        await this.AUTH.currentUser?.delete().then(() => {
                        resolve('');
                      }).catch((error) => {
                          reject(error);
                        });
                      }).catch((error) => {
                        reject(error);
                      });
                    });
                  }
                  // Eliminando mensajes
                });
              }
              // Eliminando chats
            });
          }
          // Eliminando Inventario
        })
      }, (error: any) => { reject() }, () => {});
    });
  }

  public async createCustomerSubscription(data: any, uid: string): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `${this.DATABASE_PATH}/${uid}/user_profile/payment_data/subscriptions/`);
      const PAYLOAD_AS_TEXT: string = JSON.stringify(data);
        this.httpClient.post(`${environment.cloud_functions_urls.createCustomerSubscription}`, PAYLOAD_AS_TEXT).pipe(catchError((errorTest:HttpErrorResponse): any => {
          if (errorTest.error instanceof ErrorEvent) {
            reject();
          } else {
            reject();
          }
        })).subscribe((response: any) => {
          push(DATABASE_REFERENCE, {
              checkout_session_id: '',
              checkout_link: '',
              subscription: response.data.id
          }).then(() => {
            resolve(response)
          });
        }, (error: any) => { reject() }, () => {});
    });
  }

  getProviderSelectedBrands(uid: string): Observable<any> {
    const DATABASE_REFERENCE: DatabaseReference = ref(this.DATABASE, `${this.DATABASE_PATH}/${uid}/selected_brands/`);
    return objectVal(DATABASE_REFERENCE);
  }

  public async saveIntegration(uid: string, platform: string, integrationData: any): Promise<void> {
    return new Promise((resolve, reject) => {
      const DATABASE_REFERENCE: DatabaseReference = ref(
        this.DATABASE,
        `CarFinderGeniePlatform/providers/${uid}/user_profile/integrations/${platform}`
      );

      set(DATABASE_REFERENCE, integrationData)
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public getProviderIntegration(uid: string, platform: string): Observable<any> {
    const DATABASE_REFERENCE: DatabaseReference = ref(
      this.DATABASE,
      `CarFinderGeniePlatform/providers/${uid}/user_profile/integrations/${platform}`
    );
    return objectVal(DATABASE_REFERENCE);
  }

}
